export interface WhoAmI {
	UserId: string;
	UserLogin: string;
	UserEmail: string;
	UserName: string;
	UserStatus: EnPortalUserStatus;
	UserRole: EnPortalUserRole;
	UserAsEndUser: {
		AsAddContact: null;
		Email: string;
		Id: string;
		Login: string;
		Name: string;
		TarifPlansControlType: EnSdkTarifPlansControlType;
	} | null;
}

export interface Sdk_Fe_KvmKubernetesFlexSpecialCost {
	NewCost: number;
	NewSpecialPriceDateTo?: string;
	ID: string;
}

export enum EnPortalUserStatus {
	UserDisabled = 0,
	UserActive = 1,
	UserNonActive = 2,
	UserEmailNotConfirmed = 3,
	UserDidNotCheckHisData = 4,
	UserIsAutoBlocked = 5,
}

export enum EnSdkTarifPlansControlType {
	'None' = 0,
	'Full' = 1,
}

export interface Sdk_Fc_KvmKubernetesFlexSLB {
	InternalPort?: number;
	ExternalPort?: number;
	NodeBaseRoleID?: number;
}

export interface Sdk_Fc_KvmKubernetesFlex {
	VersionID?: string;
	Name?: string;
	Note?: string;
	WorkNodesCount?: number;
	WorkNodesRoleName?: string;
	VirtualizationHostId?: string;
	VmConfigurationId?: string;
	KubeflexTypeId?: string;
	SystenDisk?: Sdk_Fc_KvmKubernetesFlexDisk;
	Network?: Sdk_Fc_KVMNetWorkConnection;
	InTest?: boolean;
	ActivateAfterTestOut?: boolean;
	SLB?: Sdk_Fc_KvmKubernetesFlexSLB[];
}

export interface Sdk_Fc_KVMNetWorkConnection {
	NewKVMNetWork?: Sdk_Fc_NewKVMNetWork;
	ExecKVMNetWork?: Sdk_Fc_ExecKVMNetWork;
	ExecVLAN?: Sdk_Fc_ExecVLAN;
	ExtIP?: Sdk_Fc_ExtIP;
}

export interface KubeflexTemplateInfo {
	SystemDiskMinSize: number;
	RamMinSize: number;
}

export interface Sdk_Fc_NewKVMNetWork {
	Description?: string;
	SubnetCIDR?: string;
	Dns1?: string;
	Dns2?: string;
	StaticNATIp?: Sdk_ExternalIp;
	PublicIp?: Sdk_ExternalIp;
	NatRules?: Sdk_Fc_KvmNatRule[];
}
export interface Sdk_Fc_ExecKVMNetWork {
	NetworkName?: string;
	StaticNATIp?: Sdk_ExternalIp;
	NatRules?: Sdk_Fc_KvmNatRule[];
}
export interface Sdk_Fc_ExecVLAN {
	RegionId?: string;
	VlanId?: number;
	VlanIPv4?: string;
}
export interface Sdk_Fc_ExtIP {
	Ip?: Sdk_ExternalIp;
	subnetID?: string;
}
export interface Sdk_ExternalIp {
	ID?: string | null;
	IpType?: 1 | 2;
}
export interface Sdk_Fc_KvmNatRule {
	ID?: string;
	InternalPort?: number;
	ExternalPort?: number;
}

export interface Sdk_Fc_KvmKubernetesFlexDisk {
	DiskSizeGB: number;
	DiskTypeConfigurationId?: string;
}

export interface KubeflexAvailableNetworksInfo {
	ExecNatRules?: Sdk_KVMDNatWide[];
	KvmExtIPTypeAvailableForIaz?: boolean;
	KvmProtectedIPTypeAvailableForIaz?: boolean;
	ExtIPTypeAvailableForIaz?: boolean;
	ProtectorExtipIPTypeAvailableForIaz?: boolean;
	AvailableNetworks?: KVMAvailableNetworkInfo[];
	ExtNATIPTypes?: number[];
	ExtIPTypes?: number[];
	ExecIPs?: KubeflexExecIPInfo[];
	AvailableIPNetworks?: KVMAvailableIPNetworkInfo[];
	ExtIpVLanTypes?: number[];
	NetworkNetworkDescription?: string;
	NetworkDescriptionShablon?: string;
	HnvNetworkCount?: number;
	NetworkSubnetCIDR?: string;
	NetworkSubnetDns1?: string;
	NetworkSubnetDns2?: string;
}

export interface Sdk_KVMDNatWide {
	ExternalIPAddress?: Sdk_IPAddress;
	Name?: string;
	KVMNetworkID?: string;
	KvmVmInernelAdapterID?: string;
	ExternalIPAddressID?: string;
	ExternalPort?: number;
	ExternalPortTo?: number;
	Protocol?: number;
	InternalPort?: number;
	InternalPortTo?: number;
	ID?: string;
	Sec_Created?: string;
	Sec_Who_Created?: string;
	Sec_Changed?: string;
	Sec_Who_Changed?: string;
}

export interface KVMAvailableNetworkInfo {
	NetworkID: string;
	NetworkType?: number;
	NetworkKvmName: string;
	RegionID?: string;
	VLanID?: number;
	VLanType?: number;
	Alias?: string;
	Default?: boolean;
	OutboundNatIPAddressID?: string;
	ProxMoxClasterId?: string;
}

export interface KubeflexExecIPInfo {
	ID?: string;
	IpTypeID?: number;
	IpTypeName?: string;
	RegionID?: string;
	IP?: string;
	Mask?: string;
	Gateway?: string;
	Dns1?: string;
	Dns2?: string;
	State?: number;
	Status?: number;
	TestPeriodEndDate?: string;
	TestPeriodEndDateExperied?: boolean;
}

export interface KVMAvailableIPNetworkInfo {
	ID?: string;
	Name?: string;
	IpTypeName?: string;
	NetworkTypeID?: string;
}

export interface Sdk_IPAddress {
	VirtualSubnetworkID?: string;
	RegionID?: string;
	SubscriptionID?: string;
	FixVmConfiguration_InstanceID?: string;
	ResourceGroupID?: string;
	IP?: number;
	Note?: string;
	Cost?: number;
	State?: number;
	Status?: number;
	LocalAddress?: boolean;
	SpecialPriceDateTo?: string;
	BookingDate?: string;
	BlockedDate?: string;
	DeletedDate?: string;
	ID?: string;
	Sec_Created?: string;
	Sec_Who_Created?: string;
	Sec_Changed?: string;
	Sec_Who_Changed?: string;
}

export interface KubeflexConfigurationForCreateInfo {
	KaasActiveTestPeriods?: number;
	IsEndUser?: boolean;
	CanEditTp?: boolean;
	AllowTest?: boolean;
	VmConfigurations?: KvmKubeflexConfigurationInfoShort[];
	VmTypeRegionCodDefaults?: Sdk_KvmVmTypeRegionCodDefaults[];
	DiskTypeConfigurationInfos?: KvmDiskTypeConfigurationInfos[];
	IpTypeInfo?: IPTypeInfoKubeflex[];
	Regions?: RegionInfos[];
	CODs?: CODInfos[];
	VmTypes?: VmTypesInfoKubeflex[];
	OSTypes?: VmTemplateScriptKind[];
	WlDiscountPercents?: WlDiscountPercentsKubeflex[];
	Versions?: VersionsInfos[];
}

export interface VersionsInfos {
	KubernetesFlexTypeId?: string;
	VersionId?: string;
	VersionName?: string;
}

export interface KvmKubeflexConfigurationInfoShort {
	KubeflexSystemNodesCount?: number;
	KubeflexFrontendNodesCount?: number;
	KubeflexMasterNodesCount?: number;
	KubeflexTypeTestPeriodDaysCount: number;
	KubeflexTypeSimultaneouslyInTestForUser?: number;
	KubeflexTypeSimultaneouslyInTestForWL?: number;
	KubeflexTypeID?: string;
	KubeflexTypeWorkerNodeMinDiskSize?: number;
	KubeflexTypeName?: string;
	KubeflexTypeDnsTemplate?: string;
	KubeflexMasterNodesConfigurationId?: string;
	KubeflexSystemNodesConfigurationId?: string;
	KubeflexFrontendNodesConfigurationId?: string;
	KubeflexMasterNodesDiskTypeConfigurationId?: string;
	KubeflexSystemNodesDiskTypeConfigurationId: string;
	KubeflexFrontendNodesDiskTypeConfigurationId?: string;
	KubeflexMasterNodesDiskSize?: number;
	KubeflexSystemNodesDiskSize?: number;
	KubeflexFrontendNodesDiskSize?: number;
	KubeflexNodesTemplateId?: string;
	KubeflexControlNodeTemplateID?: string;
	RegionId?: string;
	RegionName?: string;
	CodId?: number;
	CodName?: string;
	VmTypeId?: string;
	VmTypeVisibility?: number;
	VmTypeName?: string;
	VmTypeNote?: string;
	VmTypeWeight?: number;
	VCpuPolicyID?: string;
	VCpuPolicyReservationPercent?: number;
	VCpuPolicyMaxPercent?: number;
	CodblockId?: string;
	ProxMoxClasterID?: string;
	VirtualizationHostID?: string;
	VirtualizationHostDefault?: boolean;
	KvmPathID?: string;
	VmTemplateScriptKind?: number;
	VmTemplateScriptKindName?: string;
	Clustered?: boolean;
	TestPeriodDaysCount: number;
	ID: string;
	CodblockProxMoxClasterKey: string;
	VmConfigurationId?: string;
	CPU: number;
	RAM: number;
	CostPerMinute: number;
	KubeflexTypeNote: string;
}

export interface Sdk_KvmVmTypeRegionCodDefaults {
	ID: string;
	KvmVmTypeID: string;
	RegionID: string;
	IsRegionDefault: boolean;
	DefaultCodID?: number;
}

export interface KvmDiskTypeConfigurationInfos {
	diskTypeConfigurationId: string;
	VmTypeId?: string;
	CodblockId?: string;
	ProxMoxClasterID?: string;
	DiskTypeId?: string;
	DiskTypeName?: string;
	CostPerGb?: number;
	QOSPolId?: string;
	SizeFrom: number;
	SizeTo: number;
	Clustered?: number;
	AvailableToUse?: number;
	DiskTypeVisibility?: number;
	ID: string;
	CodblockProxMoxClasterKey: string;
	DiskTypeNote?: string;
}

export interface IPTypeInfoKubeflex {
	IPTypeIDForWlDisc?: string;
	IPType?: string;
	VirtualSubnetworkID?: string;
	Cost?: number;
}

export interface RegionInfos {
	VmTypeId?: string;
	Id?: string;
	Name?: string;
	Weight?: number;
}

export interface CODInfos extends RegionInfos {
	RegionId?: string;
}

export interface VmTypesInfoKubeflex {
	ID?: string;
	Name?: string;
	Note?: string;
	DiskTypesForSystemDisk?: string[];
}

export interface VmTemplateScriptKind {
	Key: 0 | 1 | 2;
	Id: number;
	Name: string;
}

export interface WlDiscountPercentsKubeflex {
	ID: string;
	DiscountPercent?: number;
}

export interface Sdk_UserFindFilter extends Sdk_BaseFindFilter {
	ID?: string[];
	SubscriptionID?: string[];
	Role?: number[];
	Login?: string;
	StrictLogin?: boolean;
	Email?: string;
	StrictEmail?: boolean;
	UserName?: string;
	StrictUserName?: boolean;
	ActualOnly?: boolean;
}

export interface Sdk_UserList {
	records: Sdk_User[];
	_metadata: Sdk_Pagination;
}

export interface Sdk_User {
	ID: string;
	ParentID: string;
	Login: string;
	Email: string;
	Name: string;
	Role: EnPortalUserRole;
	Phone: string;
	ArchiveDate: string;
	ContractNumber: string;
	ContractDate: string;
}

export enum EnPortalUserRole {
	Administrator = 0,
	Reseller = 1,
	User = 2,
	WLReseller = 3,
	ITProAgent = 4,
	FirstLineSupport = 5,
	UIC = 6,
}

export interface Sdk_WLPartnerEndUserFinFilter extends Sdk_BaseFindFilter {
	ID?: string[];
	WLPartnerUserID: string[];
	LoginName?: string;
	StrictLoginName?: boolean;
	FullName?: string;
	StrictFullName?: boolean;
}

export interface Sdk_WLPartnerEndUser {
	WLPartnerUserID: string;
	LoginName: string;
	StatusID: WLPartnerEndUserStatus;
	EMail: string;
	SecondEMail: string;
	Phone1: string;
	Phone2: string;
	FullName: string;
	Note: string;
	CompanyName: string;
	INN: string;
	ID: string;
	Sec_Created: string;
}

export enum WLPartnerEndUserStatus {
	UserActive = 0, // нормальный рабочий режим
	UserIsBlocked = 1, // в этом случае все его ресурсы переходят в статус «добровольная блокировка»
	UserDisabled = 2, // не может быть привязанных услуг, нельзя авторизоваться
}

export interface Sdk_WLPartnerEndUserList {
	records: Sdk_WLPartnerEndUser[];
	_metadata: Sdk_Pagination;
}

export interface Sdk_KubeflexList {
	records: Sdk_KvmKubernetesFlex_Wide[];
	_metadata: Sdk_Pagination;
}

export interface Sdk_KvmKubernetesFlex_Wide {
	Subscription?: Sdk_Subscription;
	NodeInfo?: Sdk_KvmKubernetesFlexNodeInfo[];
	NodeGroupInfo?: Sdk_KvmKubernetesFlexNodeGroupInfo[];
	TestPeriod?: Sdk_TestPeriodBase;
	WorkerNodeConfiguration?: Sdk_KvmKubernetesFlexWorkerNodeConfiguration;
	NodeRoles?: Sdk_KvmKubernetesFlexNodeRole[];
	Nodes?: Sdk_KvmKubernetesFlexNode[];
	SystemServices?: Record<string, string>[];
	Storehouse?: Sdk_ServiceStorehouseBase;
	ProxMoxClasterID?: string;
	KubernetesFlexTypeID?: string;
	KubernetesFlexTypeName?: string;
	KubernetesFlexTypeNote?: string;
	ProxMoxVNet?: Sdk_KVMNetworkBase;
	SubscriptionID?: string;
	ProxMoxVNetID?: string;
	KubernetesFlexName?: string;
	Name?: string;
	Note?: string;
	SystemServiceDNSNameTemplate?: string;
	AdminLogin?: string;
	AdminPassword?: string;
	Status: SdkServiceStatus;
	State?: SdkServiceLifeCycleState;
	TechnicalState?: string;
	MoveIntoCommercialModeOnTestOut?: boolean;
	CostPerMinute: number;
	Cost: number;
	CostWithWlDisc: number;
	ComputeCost?: string;
	ComputeCostWithDisc?: string;
	DiskSpaceCost?: string;
	DiskSpaceCostWithDisc?: string;
	WlDiscPercent?: number;
	Unit?: string;
	SpecialPriceDateTo?: string;
	StatusBeforeBlockID?: number;
	BlockedDate?: string;
	ResourceGroupID?: string;
	WLPartnerEndUserId?: string;
	ID: string;
	Sec_Created?: string;
	Version?: string;
	KuberConfig?: string;
	Region?: {
		Name?: string;
		Note?: string;
		ID?: string;
	};
}

export interface Sdk_KvmKubernetesFlexNodeGroupInfo {
	Cost?: number;
	CostWithDisc?: number;
	ComputeCost?: number;
	ComputeCostWithDisc?: number;
	DiskSpaceCost?: number;
	DiskSpaceCostWithDisc?: number;
	Role?: EnSdkKvmKubernetesFlexNodeBaseRole;
	RoleName?: string;
	KvmVmTypeID?: string;
	KvmVmTypeName?: string;
	CPU?: number;
	RAM?: number;
	Disk?: string;
	Count?: number;
}
export interface Sdk_KvmKubernetesFlexNodeInfo {
	Cost?: number;
	CostWithDisc?: number;
	ComputeCost?: number;
	ComputeCostWithDisc?: number;
	DiskSpaceCost?: number;
	DiskSpaceCostWithDisc?: number;
	State: SdkServiceLifeCycleState;
	Role?: EnSdkKvmKubernetesFlexNodeBaseRole;
	KvmVmTypeID?: string;
	KvmVmTypeName?: string;
	CPU?: number;
	RAM?: number;
	Disk?: string;
	Created?: string;
}

export interface Sdk_KvmKubernetesFlexFindFilter {
	ID?: string[];
	CreatedFromDate?: string;
	CreatedToDate?: string;
	KubernetesFlexName?: string;
	StrictKubernetesFlexName?: boolean;
	Name?: string;
	StrictName?: boolean;
	StatusID?: SdkServiceStatus[];
	StateID?: SdkServiceLifeCycleState[];
	WLPartnerEndUserLoginLike?: string;
	StrictWLPartnerEndUserLogin?: boolean;
	WLPartnerEndUserFullNameLike?: string;
	ContextFind?: string;
	HasSpecialPriceDateTo?: boolean;
	NotHasSpecialPriceDateTo?: boolean;
	SearchInActualAccounts?: boolean;
	SearchInArchiveAccounts?: boolean;
	SortFieldName?: string;
	SortOrder: SortOrder;
	UserLogin?: string;
	StrictUserLogin?: boolean;
	Page?: number;
	PerPage?: number;
}

export interface Sdk_Fe_KvmKubernetesFlex {
	ID: string;
	Name?: string;
	Note?: string;
	SystemServiceDNSNameTemplate?: string;
	AdminLogin?: string;
	AdminPassword?: string;
	WLPartnerEndUserId?: string;
}

export interface Sdk_KvmKubernetesFlexWorkerNodeConfiguration {
	ID: string;
	KvmKubernetesFlexID?: string;
	NodeCount?: number;
	KvmVmConfigurationID?: string;
	KvmDiskTypeConfigurationID?: string;
	DiskSize?: number;
}

export interface Sdk_KvmKubernetesFlexNodeRole {
	ID: string;
	KvmKubernetesFlexID?: string;
	Name?: string;
	BaseRole?: number;
	IsProtected?: boolean;
}

export interface Sdk_KvmKubernetesFlexNode {
	ID: string;
	KvmKubernetesFlexID?: string;
	KvmVmID?: string;
	KvmKubernetesFlexNodeRoleID?: string;
	KvmState?: string;
}

export interface Sdk_ServiceStorehouseBase {
	MaxFreeCost?: number;
	ID: string;
	Sec_Created?: string;
}

export interface Sdk_KVMNetworkBase {
	ID: string;
	Name?: string;
	Description?: string;
	State: SdkServiceLifeCycleState;
	SubNetworks?: Sdk_KVMSubNetwork[];
	OutboundNatIPAddress?: Sdk_IpAddress;
}

export interface Sdk_IpAddress {
	ID: string;
	Cost?: number;
	CostWithWlDiscount?: number;
	IP: number;
}

export interface Sdk_KVMSubNetwork {
	ID: string;
	SubnetCIDR?: string;
	Gateway?: number;
	Dns1?: number;
	Dns2?: number;
}

export interface Sdk_TestPeriodBase {
	TestPeriodStarted: string;
	TestPeriodEnded: string;
	TestPeriodMustEnd: string;
	TestPeriodStatus: SdkTestPeriodStatus;
	ID: string;
	Sec_Created: string;
}

export interface Sdk_SubscriptionFindFilter extends Sdk_BaseFindFilter {
	ID?: string[];
	UserID?: string[];
	NameLike?: string;
	StrictName?: boolean;
	State?: SdkServiceLifeCycleState;
	Status?: SdkServiceStatus;
}

export interface Sdk_SubscriptionList {
	records: Sdk_Subscription[];
	_metadata: Sdk_Pagination;
}

export interface Sdk_Subscription {
	UserID: string;
	UserLogin?: string;
	Name?: string;
	Description?: string;
	State?: SdkServiceLifeCycleState;
	Status?: SdkServiceStatus;
	StartDate?: string;
	EndDate?: string;
	ID?: string;
	Sec_Created?: string;
}

export interface Sdk_KvmKubernetesFlexCalculation {
	FileName?: string;
	buffer?: string;
}

export interface Sdk_Fc_KvmKubernetesFlexCalculation {
	parameters: Sdk_KvmKubernetesFlexCalculationParameter[];
}

export interface Sdk_KvmKubernetesFlexCalculationParameter {
	VmId?: string;
	Hide?: boolean;
	WlDiscountPercent?: number;
	FieldSet?: string;
	AddInfo?: string;
	ChildrenParameters?: Sdk_KvmKubernetesFlexCalculationChildrenParameter[];
	WarningMessage?: string;
	Status?: number;
	ID?: string;
	Name?: string;
	Cost?: number;
	GroupId?: string;
}

export interface Sdk_KvmKubernetesFlexCalculationChildrenParameter {
	ID?: string;
	Name?: string;
	Cost?: number;
}

export interface Sdk_Pagination {
	PageNumber?: number;
	RecordsPerPage: number;
	PagesCount?: number;
	RecordsCount?: number;
}
export interface ErrorResponse {
	ErrorCode?: number;
	ErrorText: string;
	ValidationErrors?: ValidationError[];
}

interface ValidationError {
	EntityType: string;
	EntityId: string | null;
	PropertyName: string;
	PropertyValue: string;
	ErrorCode: string | null;
	ErrorText: string;
}

interface Sdk_BaseFindFilter {
	SortFieldName?: string;
	SortOrder?: SortOrder;
	Page?: number;
	PerPage?: number;
}

export interface Sdk_ActivateIaasServiceAfterTestoutParams {
	Activate: boolean;
	ActivateRightNow: boolean;
	ID: string;
}

export interface Sdk_ServiceTestPeriodProlongInfo {
	NewTestPeriodEndDate: string;
	ID: string;
}

export enum SortOrder {
	'Asc' = 0, // По возрастанию
	'Desc' = 1, // По убыванию
}

export enum SdkServiceStatus {
	'Blocked' = 0, // Принудительная блокировка
	'Active' = 1, // Активен
	'Test' = 2, // Тестовый режим
	'VoluntaryBlocked' = 3, // Добровольная блокировка
	'TestOut' = 4, // Тестовый период завершен
}

export enum SdkServiceLifeCycleState {
	'CreatingError' = -1, // Ошибка создания
	'Ready' = 0, // Объект готов к использованию
	'Creating' = 1, // Объект создается
	'Modifying' = 2, //  Объект модифицируется
	'Deleting' = 3, // Объект удаляется
	'Deleted' = 4, // Объект удален
	'ModifyingError' = 5, //  Ошибка модифицирования
	'DeletingError' = 6, // Ошибка удаления
}

export enum SdkTestPeriodStatus {
	'NotActive' = 0,
	'Active' = 1,
}

export enum EnSdkKvmKubernetesFlexNodeBaseRole {
	'Master' = 0,
	'System' = 1,
	'Worker' = 2,
	'Frontend' = 3,
}
